import React from "react";
import { Box, Button, Theme, Typography } from "@mui/material";
import { NO_ANSWER_YET, ProbateField } from "../../../models/ProbateField";
import { ProbateFieldQuestion } from "./ProbateFieldQuestion";

interface Props {
  field: ProbateField;
  setQuestionComponent: (component?: JSX.Element) => void;
  onAnswer: (answer: string | number | boolean) => Promise<void>;
  first?: boolean;
  highlight?: boolean;
}

export const RenderEditableField = ({
  field,
  setQuestionComponent,
  onAnswer,
  first = false,
  highlight = false,
}: Props): JSX.Element => {
  const noAnswerYet = field.answer === NO_ANSWER_YET;

  return (
    <>
      {!first && (
        <hr
          color="#ccc"
          style={{ height: "1px", border: "none", marginTop: 20 }}
        />
      )}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: !first ? 3 : 0,
        }}
      >
        <Box>
          <Typography
            variant="body2"
            sx={{
              color: (theme: Theme) =>
                highlight ? theme.palette.error.light : "none",
            }}
          >
            {field?.answerLabel}
          </Typography>
          <Typography>
            {field?.answer !== NO_ANSWER_YET ? field?.prefix : ""}
            {field?.answer}
          </Typography>
        </Box>
        <Button
          variant={noAnswerYet ? "contained" : "outlined"}
          color="secondary"
          sx={{ minWidth: 100 }}
          size="small"
          onClick={() => {
            setQuestionComponent(
              <ProbateFieldQuestion field={field} onAnswer={onAnswer} />
            );
          }}
        >
          {noAnswerYet ? "Start" : "Edit"}
        </Button>
      </Box>
    </>
  );
};
